<template>
    <div class="dat-loader"/>
</template>

<script>
    export default {
        props: {
        },
    };
</script>
